import React from 'react';
import { cn } from './cn';

const POS = {
  top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
  bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
  left: 'right-full top-1/2 -translate-y-1/2 mr-2',
  right: 'left-full top-1/2 -translate-y-1/2 ml-2',
};

/**
 * Tooltip nhẹ (CSS group-hover, không cần thư viện định vị).
 * Bọc quanh phần tử cần chú thích. side: top|bottom|left|right.
 */
export function Tooltip({ content, side = 'top', children, className }) {
  if (!content) return children;
  return (
    <span className="relative inline-flex group">
      {children}
      <span
        role="tooltip"
        className={cn(
          'pointer-events-none absolute z-50 whitespace-nowrap rounded-lg bg-gray-900 px-3 py-2 text-sm font-medium text-white opacity-0 shadow-md transition-opacity duration-200 group-hover:opacity-100 dark:bg-gray-700',
          POS[side] || POS.top,
          className
        )}
      >
        {content}
      </span>
    </span>
  );
}

export default Tooltip;
